import { getBracketGameEndDate } from './getBracketGameEndDate'
import { type BracketGameData, type GameData, type BracketRound } from '@terros/common'

type ShiftBracketStartDateOptions = {
  currentRounds: BracketRound[]
  newStartDate: number
  announceDate?: number
}

export const shiftBracketStartDate = (
  options: ShiftBracketStartDateOptions
): Pick<BracketGameData, 'rounds' | 'endDate' | 'announceDate'> => {
  const { currentRounds, newStartDate, announceDate } = options
  const firstRoundStartDate = currentRounds.reduce((acc, round) => {
    return Math.min(acc, round.startDate)
  }, Infinity)
  const shiftedDuration = newStartDate - firstRoundStartDate
  const updatedRounds = currentRounds.map((round) => {
    return {
      ...round,
      startDate: round.startDate + shiftedDuration,
      endDate: round.endDate + shiftedDuration,
    }
  })
  const updatedEndDate = getBracketGameEndDate({ rounds: updatedRounds, startDate: newStartDate })
  const updatedAnnounceDate = shiftAnnounceDate(announceDate, shiftedDuration, newStartDate)
  return { rounds: updatedRounds, endDate: updatedEndDate, announceDate: updatedAnnounceDate }
}

export const shiftStartDate = (
  previous: Pick<GameData, 'startDate' | 'announceDate' | 'endDate'>,
  newStartDate: number
): Pick<GameData, 'startDate' | 'announceDate' | 'endDate'> => {
  const difference = newStartDate - previous.startDate
  return {
    ...previous,
    startDate: newStartDate,
    announceDate: shiftAnnounceDate(previous.announceDate, difference, newStartDate),
    endDate: previous.endDate + difference,
  }
}

export const shiftAnnounceDate = (announceDate: number | undefined, difference: number, fallback: number): number => {
  if (!announceDate) return fallback

  const now = Date.now()
  if (announceDate < now) return announceDate
  const updatedAnnounceDate = announceDate + difference
  if (updatedAnnounceDate < now) return fallback
  return updatedAnnounceDate
}
